import Image from 'next/image';

type MagazinePromotedArticleAuthorAvatarProps = {
  name: string;
  imageSrc?: string;
};

function MagazinePromotedArticleAuthorAvatar({ name, imageSrc }: MagazinePromotedArticleAuthorAvatarProps) {
  const initial = name.charAt(0).toUpperCase();

  if (imageSrc) {
    return <Image src={imageSrc} alt="" width={40} height={40} className="size-10 rounded-full object-cover" data-testid="magazine-promoted-carousel-author-avatar-image" />;
  }

  return (
    <div
      className="bg-accent-green text-secondary flex size-10 items-center justify-center rounded-full paragraph-strong"
      data-testid="magazine-promoted-carousel-author-avatar-initial"
    >
      {initial}
    </div>
  );
}

export { MagazinePromotedArticleAuthorAvatar, type MagazinePromotedArticleAuthorAvatarProps };
